import React, {Component} from 'react';
import {View, TouchableOpacity, I18nManager, ActivityIndicator, Image, Platform, Alert} from 'react-native';
import {moderateScale} from "../../../../../tools/Scaling";
import * as NavigationService from '../../../../../redux/NavigationService';
import HMTextView from "../../../../../customviews/HMTextView";
import Colors from "../../../../../tools/Colors";
import {connect} from "react-redux";
import store from "../../../../../redux/store";
import HMIcon from "../../../../../customviews/HMIcon";
import HMSwiper from "../../../../../customviews/swiper/HMSwiper";
import HMImageView from "../../../../../customviews/HMImageView";

class AdapterListOperatorApply extends Component {

    componentWillMount() {

    }

    constructor(props) {
        super(props);
    }

    state = {
        indexLoading: -1
    }

    componentWillReceiveProps(propss) {

    }

    componentWillUnmount() {

    }

    setData(item) {
        //   this.props.callService(typeExport.urlSetMyApplyScreen, `?property=${item.id}&apply_notify=${!(item.apply_notify)}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeSetMyApplyScreen, 'POST', 0, 0, item.id)

    }

    /*  isCherries(fruit) {
         return fruit.name === 'cherries';
     }*/
    render() {
        let {item, index, navigation, item_parent, hiddenModal, type, resultAll} = this.props;
        //   let data = this.props.item;
        // let fileAudio = item.audio || item.audio === null ? item.audio : (item.files && item.files.length > 0 && (item.files.find(k => k.type === 'audio/aac')))
        // let fileImage = item.image || item.image === null ? item.image : (item.files && item.files.length > 0 && (item.files.find(k => k.type === 'image/jpeg')))
        // let fileVideo = item.video || item.video === null ? item.video : (item.files && item.files.length > 0 && (item.files.find(k => k.type === 'video/mp4')))

        let fileAudio = item.audio || item.audio === null ? item.audio : (item.files && item.files.length > 0 && (item.files.find(k => k.type.search('audio/') >= 0)));
        let fileImage = item.image || item.image === null ? item.image : (item.files && item.files.length > 0 && (item.files.find(k => k.type.search('image/') >= 0)));
        let fileVideo = item.video || item.video === null ? item.video : (item.files && item.files.length > 0 && (item.files.find(k => k.type.search('video/') >= 0)));
        let {ListNotSendMyApply} = store.getState().reducerSplashGetAllData
        return (


            <TouchableOpacity style={{
                flex: 1,
                //   alignSelf: "center",
                paddingHorizontal: moderateScale(4),
                marginHorizontal: moderateScale(8)
            }}
                              onPress={() => {

                                  //  this.props.callServiceShowWebView("")
                                  NavigationService.navigateParams("DetailsOperatorApplyScreen", {
                                      resultAll: resultAll,
                                      item: item,
                                      item_parent: item_parent,
                                      type: type,
                                      indexExtra: index
                                  })
                                  hiddenModal()
                              }}
                //onPress={() =>NavigationService.navigateParams("VideoScreen", {id: item.id}) }

            >
                {
                    1 == 1 ?

                        <View
                            style={{
                                padding: moderateScale(6),
                                // flexDirection: "row",
                                width: "100%",
                                // flex: 1,
                                marginVertical: moderateScale(4),
                                borderRadius: moderateScale(5),
                                backgroundColor: Colors.backgroundColor,

                                // justifyContent: "flex-end"
                            }}>

                            <View style={{width: "100%", flexDirection: 'row',}}>
                                <View style={{flexDirection: 'row', flex: .33,}}>
                                    <HMTextView type={"bold"}
                                                noFont={!I18nManager.getConstants().isRTL}
                                                style={{
                                                    fontSize: moderateScale(14),
                                                    marginHorizontal: moderateScale(5),
                                                    color: Colors.blackLight,
                                                    // marginTop: moderateScale(10)
                                                }}
                                        // text={"1423578"}
                                                text={item.messageno ? item.messageno : (I18nManager.getConstants().isRTL ? " ." + (index + 1) : (index + 1) + " .")}
                                        //   text={"98/03/21"}
                                    />
                                </View>
                                <View
                                    style={{
                                        flex: .33, flexDirection: 'row',
                                        // alignItems: 'center',
                                        justifyContent: 'center'
                                        //    backgroundColor:'#96ee5b'
                                    }}>
                                    <HMTextView
                                        //type={"bold"}
                                        noFont={!I18nManager.getConstants().isRTL}
                                        style={{
                                            fontSize: moderateScale(11),
                                            color: Colors.colorDark,
                                            textAlign: 'center',
                                            //alignSelf:'center',
                                            // marginTop: moderateScale(10)
                                        }}
                                        //  text={'1398/05/03'}
                                        text={item.createdtime ? item.createdtime : item.date}
                                        //   text={"98/03/21"}
                                    />
                                </View>
                                <View style={{flexDirection: 'row', flex: .33, justifyContent: 'flex-end'}}>
                                    {

                                        <HMTextView type={"bold"}
                                                    noFont={!I18nManager.getConstants().isRTL}
                                                    style={{
                                                        fontSize: moderateScale(10),
                                                        color: item.color ? item.color : Colors.gray,
                                                        // marginTop: moderateScale(10)
                                                    }}
                                                    text={item.status}
                                            //   text={"98/03/21"}
                                        />

                                    }

                                </View>
                            </View>
                            <View
                                style={{
                                    flexDirection: "row",
                                    width: "100%",
                                    justifyContent: "space-between",
                                    marginVertical: moderateScale(8)
                                }}
                            >

                                <View
                                    style={{
                                        flex: 1,
                                        padding: moderateScale(4)
                                        //    justifyContent: 'flex-end'
                                    }}>
                                    <HMTextView
                                        type={"bold"}
                                        noFont={!I18nManager.getConstants().isRTL}
                                        style={{
                                            fontSize: moderateScale(11),
                                            color: Colors.colorDark,
                                            // marginTop: moderateScale(10)
                                        }}
                                        //text={'آسیب های اجتماعی'}
                                        text={item.title ? item.title : item.category}
                                        //   text={"98/03/21"}
                                    />

                                    <HMTextView
                                        //type={"bold"}
                                        noFont={!I18nManager.getConstants().isRTL}

                                        style={{
                                            fontSize: moderateScale(11),
                                            marginVertical:moderateScale(5),
                                            //  marginBottom: moderateScale(8),
                                            color: Colors.red,
                                            // marginTop: moderateScale(10)
                                        }}
                                        text={item.importance}
                                        //   text={"98/03/21"}
                                    />

                                    {
                                        item.LatestRefrence ?
                                            <View style={{flexDirection: "row",}}>
                                                <HMTextView
                                                    //type={"bold"}
                                                    noFont={!I18nManager.getConstants().isRTL}

                                                    style={{
                                                        fontSize: moderateScale(11),
                                                        //  marginBottom: moderateScale(8),
                                                        color: Colors.blue,
                                                        // marginTop: moderateScale(10)
                                                    }}
                                                    text={"آخرین ارجاع : "}
                                                    //   text={"98/03/21"}
                                                />
                                                <HMTextView
                                                    //type={"bold"}
                                                    noFont={!I18nManager.getConstants().isRTL}

                                                    style={{
                                                        fontSize: moderateScale(11),
                                                        //  marginBottom: moderateScale(8),
                                                        color: Colors.blackLight,
                                                        // marginTop: moderateScale(10)
                                                    }}
                                                    text={item.LatestRefrence}
                                                    //   text={"98/03/21"}
                                                />
                                            </View>
                                            :
                                            null
                                    }

                                </View>
                                <View style={{
                                    flexDirection: "row",

                                    // height: moderateScale(48),
                                    //   width: moderateScale(110),
                                }}>
                                    {
                                        item.flagExpert || item.flagExpertAdmin ?
                                            <TouchableOpacity
                                                style={{
                                                    width: moderateScale(40),
                                                    height: moderateScale(40),
                                                    marginHorizontal: moderateScale(6)
                                                }}
                                                onPress={() => {
                                                    if (!item.flagExpertAdmin && item.flagExpert)
                                                    // if (item.flagExpert)
                                                        NavigationService.navigateParams("ExpertRegistrationMahaleMaScreen", {
                                                            itemExtra: item,
                                                            type: "",
                                                            indexExtra: index
                                                        })
                                                }}
                                            >
                                                <HMImageView
                                                    resizeMode={'contain'}
                                                    uriComplete={item.imageExpert ? item.imageExpert : "http://portal.arak.ir/layouts/v7/lib/todc/img/worker.png?v=1"}
                                                    _backgroundColorLoading={Colors.transparent}
                                                    styleImage={{
                                                        //  resizeMode: 'cover',
                                                        width: "100%",
                                                        height: "100%",
                                                        // backgroundColor: "#ee7e0c",
                                                        //  borderTopRightRadius:moderateScale(8),
                                                        //borderTopEndRadius: moderateScale(12),
                                                        // borderTopStartRadius: moderateScale(8),
                                                    }}
                                                    //  onLoad={this._onLoad}
                                                    //   onError={status !== 3 ? this._onError : undefined} // prevent infinite-loop bug
                                                />

                                            </TouchableOpacity>
                                            :
                                            null
                                    }
                                    {
                                        item.flagDistrict ?
                                            <View
                                                style={{
                                                    width: moderateScale(40),
                                                    height: moderateScale(40),
                                                }}
                                            >
                                                <HMImageView
                                                    resizeMode={'contain'}
                                                    uriComplete={item.imageDistrict ? item.imageDistrict : "http://portal.arak.ir/layouts/v7/lib/todc/img/musque.png?v=1"}
                                                    _backgroundColorLoading={Colors.transparent}
                                                    styleImage={{
                                                        //  resizeMode: 'cover',
                                                        width: "100%",
                                                        height: "100%",
                                                        //  backgroundColor: "#ee7e0c",
                                                        //  borderTopRightRadius:moderateScale(8),
                                                        //borderTopEndRadius: moderateScale(12),
                                                        // borderTopStartRadius: moderateScale(8),
                                                    }}
                                                    //  onLoad={this._onLoad}
                                                    //   onError={status !== 3 ? this._onError : undefined} // prevent infinite-loop bug
                                                />
                                            </View>
                                            :
                                            null
                                    }

                                </View>
                            </View>
                            <View style={{width: "100%", flexDirection: 'row', justifyContent: "space-between"}}>
                                <View style={{flexDirection: 'row', flex: .33}}>
                                    {

                                        <TouchableOpacity style={{
                                            //flex: .3,
                                            flexDirection: 'row',

                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginHorizontal: moderateScale(5)
                                        }}>
                                            <HMIcon
                                                type={"Feather"}
                                                name={"map-pin"} style={{
                                                alignSelf: 'center',
                                                // width: moderateScale(14),
                                                color: item.latitude && item.latitude != null && item.latitude != '' ? Colors.colorPrimaryDark : Colors.gray,
                                                fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                textAlign: 'center'
                                            }}/>
                                        </TouchableOpacity>

                                    }

                                    {

                                        <TouchableOpacity style={{
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginHorizontal: moderateScale(5)
                                        }}>
                                            <HMIcon name={"md-image"} style={{
                                                alignSelf: 'center',
                                                // width: moderateScale(14),
                                                color: ((item.files && item.files.length > 0 && fileImage && fileImage.file) || item.image) ? Colors.colorPrimaryDark : Colors.gray,
                                                fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                textAlign: 'center'
                                            }}/>
                                        </TouchableOpacity>


                                    }
                                    {


                                        <TouchableOpacity style={{
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginHorizontal: moderateScale(5)
                                        }}>
                                            <HMIcon name={"md-videocam"} style={{
                                                alignSelf: 'center',
                                                // width: moderateScale(14),
                                                color: ((item.files && item.files.length > 0 && fileVideo && fileVideo.file) || item.video) ? Colors.colorPrimaryDark : Colors.gray,
                                                fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                textAlign: 'center'
                                            }}/>
                                        </TouchableOpacity>

                                    }
                                    {


                                        <TouchableOpacity style={{
                                            // flex: .33,
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginHorizontal: moderateScale(5)
                                        }}>
                                            <HMIcon name={"md-mic"} style={{
                                                alignSelf: 'center',
                                                // width: moderateScale(14),
                                                color: ((item.files && item.files.length > 0 && fileAudio && fileAudio.file) || item.audio) ? Colors.colorPrimaryDark : Colors.gray,
                                                fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                textAlign: 'center'
                                            }}/>
                                        </TouchableOpacity>

                                    }

                                </View>
                                {
                                    item.LastDay ?
                                        <View style={{
                                            flexDirection: 'row',
                                            flex: .33,
                                            justifyContent: "center",
                                        }}>
                                            {/*<HMIcon*/}
                                            {/*name={"message"}*/}
                                            {/*type={"MaterialCommunityIcons"}*/}
                                            {/*style={{*/}
                                            {/*alignSelf: 'center',*/}
                                            {/*// width: moderateScale(14),*/}
                                            {/*color: Colors.colorDark,*/}
                                            {/*marginHorizontal: moderateScale(5),*/}
                                            {/*fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),*/}
                                            {/*textAlign: 'center'*/}
                                            {/*}}/>*/}
                                            <HMTextView

                                                type={"bold"}
                                                noFont={!I18nManager.getConstants().isRTL}
                                                style={{
                                                    fontSize: moderateScale(12),
                                                    color: Colors.blackLight,

                                                    // marginTop: moderateScale(10)
                                                }}
                                                text={item.LastDay + " روز"}
                                                //   text={"98/03/21"}
                                            />
                                        </View>
                                        :
                                        null
                                }
                                {
                                    item._operation ?
                                        <View style={{flexDirection: 'row', justifyContent: 'flex-end'}}/>
                                        :
                                        <View style={{flexDirection: 'row', justifyContent: 'flex-end', flex: .33}}>
                                            <HMIcon
                                                name={"message"}
                                                type={"MaterialCommunityIcons"}
                                                style={{
                                                    alignSelf: 'center',
                                                    // width: moderateScale(14),
                                                    color: Colors.colorDark,
                                                    marginHorizontal: moderateScale(5),
                                                    fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                    textAlign: 'center'
                                                }}/>
                                            <HMTextView

                                                //type={"bold"}
                                                noFont={!I18nManager.getConstants().isRTL}
                                                style={{
                                                    fontSize: moderateScale(11),
                                                    color: Colors.gray,

                                                    // marginTop: moderateScale(10)
                                                }}
                                                text={item.comment ? (item.comment.length > 0 ? item.comment.length + "" : "0") : (item.lastWork && item.lastWork.length > 0 ? item.lastWork.length + "" : "0")}
                                                //   text={"98/03/21"}
                                            />
                                        </View>
                                }

                            </View>


                        </View>
                        :
                        <View
                            style={{
                                flex: 1
                            }}>
                            <View style={{
                                flex: 1
                            }}>
                                <View style={{
                                    width: "100%", height: moderateScale(140)
                                }}>
                                    <HMSwiper
                                        list={item.files}
                                        renderItem={() =>
                                            item.files.map((item, index) => {
                                                return <TouchableOpacity
                                                    onPress={() => {
                                                        // global.typeCategory=item.type;
                                                        NavigationService.navigateParams("DetailsScreen", {item: JSON.stringify(item)})
                                                    }}
                                                    style={{
                                                        flex: 1, alignItems: "center", justifyContent: "center",

                                                        marginHorizontal: moderateScale(4),
                                                        //  marginBottom:moderateScale(20),
                                                        //   backgroundColor:index%2===0?'#29ee0f':'#16d8ee',
                                                        backgroundColor: '#000',
                                                        //    borderTopRightRadius:moderateScale(8),
                                                        borderTopEndRadius: moderateScale(12),
                                                        borderTopStartRadius: moderateScale(8),


                                                    }}
                                                >
                                                    <HMImageView
                                                        resizeMode={'contain'}
                                                        uriComplete={item.images.file}
                                                        _backgroundColorLoading={Colors.black}
                                                        styleImage={{
                                                            //  resizeMode: 'cover',
                                                            width: "100%",
                                                            height: "100%",
                                                            backgroundColor: "#ee7e0c",
                                                            //  borderTopRightRadius:moderateScale(8),
                                                            borderTopEndRadius: moderateScale(12),
                                                            borderTopStartRadius: moderateScale(8),
                                                        }}
                                                        //  onLoad={this._onLoad}
                                                        //   onError={status !== 3 ? this._onError : undefined} // prevent infinite-loop bug
                                                    />

                                                    {
                                                        item.title ?

                                                            <View
                                                                style={[
                                                                    {
                                                                        position: 'absolute',
                                                                        bottom: 0,
                                                                        height: moderateScale(50),
                                                                        // height: typeExport._WIDTH / ((results.slider_height ? results.slider_height : 1.6) * 4),
                                                                        width: '100%',
                                                                        color: Colors.white,
                                                                        padding: moderateScale(3),
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        backgroundColor: 'rgba(0,0,0,0.5)',
                                                                    }]}
                                                            >
                                                                <HMTextView
                                                                    type={"bold"}

                                                                    style={[
                                                                        {
                                                                            // position: 'absolute',
                                                                            //  bottom: 0,
                                                                            // height: moderateScale(44),
                                                                            // width: '100%',
                                                                            textAlign: "center",
                                                                            color: Colors.white,
                                                                            fontSize: moderateScale(13),
                                                                            //  padding: moderateScale(1),

                                                                            // backgroundColor: 'rgba(0,0,0,0.25)',
                                                                        }]}
                                                                    numberOfLines={2}
                                                                    text={item.title}
                                                                />
                                                            </View>
                                                            : null
                                                    }
                                                </TouchableOpacity>
                                            })
                                        }
                                    />
                                </View>
                            </View>
                        </View>
                }

            </TouchableOpacity>


        );
    }

}

const mapStateToProps = state => {
    return {

        // resultsSet: state.reducerMyApplyScreen.resultsSet,
        // isLoadingSet: state.reducerMyApplyScreen.isLoadingSet,
        // NoInternetDialogSet: state.reducerMyApplyScreen.NoInternetDialogSet,
        // token: state.reducerSplashGetAllData.token,
        // DataSplashScreen: state.reducerSplashGetAllData,
        // id: state.reducerMyApplyScreen.id,

    };
};
const mapDispatchToProps = dispatch => {
    return {
        // callService: (url, params, type, typeConnection, page, item_count, id) => dispatch(callWebservice(url, params, type, typeConnection, page, item_count, id)),

    }
};
export default connect(mapStateToProps, mapDispatchToProps)(AdapterListOperatorApply);
